import React from "react";
import { ReactComponent as Dessert } from "../icons/dessert.svg";

const DetailProductsIcons = [
  <Dessert width={30} height={30} />,
  <Dessert width={40} height={40} />,
  <Dessert width={50} height={50} />,
];
export default DetailProductsIcons;
